import { useCallback, useEffect, useState } from 'react'

import { Col, Form, Modal, Row } from 'react-bootstrap'
import { CheckCircleFill, Search, XCircleFill } from 'react-bootstrap-icons'

import { CustomButton } from '../../../../components/CustomButton'
import { CustomDecimalInput } from '../../../../components/CustomDecimalInput'
import { CustomSpinner } from '../../../../components/CustomSpinner'
import { IconButton } from '../../../../components/IconButton'

import CategoriesService from '../../../../services/database/CategoriesService'

import { Center } from '../../../../components/Center'
import EmbalagensService from '../../../../services/database/EmbalagensService'
import PessoasService from '../../../../services/database/PessoasService'
import ProdutosService from '../../../../services/database/ProdutosService'
import WmsProductService from '../../../../services/database/WmsProductService'
import { adaptValue } from '../../../../utils/adaptValue'
import { sendErrorApiMessage } from '../../../../utils/sendErrorApiMessage'

export default function ModalProduct({
  title,
  isOpen,
  onClose,
  onSubmit,
  isRequestLoading,
  productSku,
}) {
  const [data, setData] = useState({
    id: '',
    sku: '',
    descricao: '',
    dun: '',
    embalagemarm: '',
    qtunitmaster: '',
    unimasterarm: '',
    alturaarm: '',
    larguraarm: '',
    pesoliqarm: '',
    pesobrutoarm: '',
    profundidadearm: '',
    volumearmcm: '',
    volumearmm: '',
    ean: '',
    embalagemexp: '',
    qtunimasterexp: '',
    unimasterexp: '',
    alturaexp: '',
    larguraexp: '',
    pesoliqexp: '',
    pesobrutoexp: '',
    profundidadeexp: '',
    volumeexpcm: '',
    volumeexpm: '',
    refprodut: '',
    codfabricante: '',
    fabricante: '',
    idcategoria: '',
    skupai: '',
    dtaalteracao: '',
  })
  const [categories, setCategories] = useState([])
  const [embalagens, setEmbalagens] = useState([])
  const [isCategoriesLoading, setIsCategoriesLoading] = useState(true)
  const [isEmbalagensLoading, setIsEmbalagensLoading] = useState(true)

  const [suppliers, setSuppliers] = useState([])
  const [isSuppliersLoading, setIsSuppliersLoading] = useState(true)

  const [isProductLoading, setIsProductLoading] = useState(false)
  const [isSearchProductLoading, setIsSearchProductLoading] = useState(false)

  function handleChange(e) {
    const { name, value } = e.target

    setData((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  async function handleSearchProduct() {
    try {
      setIsSearchProductLoading(true)

      const product = await ProdutosService.getBySKU(data.sku)

      setData((prevState) => ({
        ...prevState,
        descricao: product.descricao,
      }))
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível localizar o produto!')

      setData((prevState) => ({
        ...prevState,
        sku: '',
        descricao: '',
      }))
    } finally {
      setIsSearchProductLoading(false)
    }
  }

  async function loadCategories() {
    try {
      setIsCategoriesLoading(true)

      const data = await CategoriesService.getAll()

      setCategories(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível carregar as categorias!')
    } finally {
      setIsCategoriesLoading(false)
    }
  }

  async function loadSupplies() {
    try {
      setIsSuppliersLoading(true)

      const suppliersData = await PessoasService.getAllSuppliers()

      setSuppliers(suppliersData)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível carregar os fornecedores!')
    } finally {
      setIsSuppliersLoading(false)
    }
  }

  const getProductBySku = useCallback(async () => {
    try {
      setIsProductLoading(true)

      const product = await WmsProductService.getBySku(productSku)

      setData(product)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível buscar o produto!')
    } finally {
      setIsProductLoading(false)
    }
  }, [productSku])

  const calculateVolumesArm = useCallback(() => {
    const alturaarm = adaptValue(data.alturaarm) * 100
    const larguraarm = adaptValue(data.larguraarm) * 100
    const profundidadearm = adaptValue(data.profundidadearm) * 100

    const volumecm = alturaarm * larguraarm * profundidadearm
    const volumem = (volumecm / 1000000).toFixed(2)

    setData((prevState) => ({
      ...prevState,
      volumearmcm: volumecm,
      volumearmm: volumem,
    }))
  }, [data.alturaarm, data.larguraarm, data.profundidadearm])

  const calculateVolumesExp = useCallback(() => {
    const alturaexp = adaptValue(data.alturaexp) * 100
    const larguraexp = adaptValue(data.larguraexp) * 100
    const profundidadeexp = adaptValue(data.profundidadeexp) * 100

    const volumecm = alturaexp * larguraexp * profundidadeexp
    const volumem = (volumecm / 1000000).toFixed(2)

    setData((prevState) => ({
      ...prevState,
      volumeexpcm: volumecm,
      volumeexpm: volumem,
    }))
  }, [data.alturaexp, data.larguraexp, data.profundidadeexp])

  async function loadEmbalagens() {
    try {
      setIsEmbalagensLoading(true)

      const data = await EmbalagensService.getAll()

      setEmbalagens(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível carregar as embalagens!')
    } finally {
      setIsEmbalagensLoading(false)
    }
  }

  useEffect(() => {
    loadEmbalagens()
  }, [])

  useEffect(() => {
    calculateVolumesExp()
  }, [calculateVolumesExp])

  useEffect(() => {
    calculateVolumesArm()
  }, [calculateVolumesArm])

  useEffect(() => {
    if (productSku) {
      getProductBySku()
    }
  }, [getProductBySku, productSku])

  useEffect(() => {
    loadCategories()
    loadSupplies()
  }, [])

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      dialogClassName="custom-modalzpl"
    >
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {isProductLoading ? (
          <Center>
            <CustomSpinner size={60} />
            <h3
              style={{
                margin: 0,
              }}
            >
              Carregando produto...
            </h3>
          </Center>
        ) : (
          <>
            <Row className="mb-3">
              <Col md={3}>
                <Form.Label>SKU</Form.Label>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                  }}
                >
                  <Form.Control
                    name="sku"
                    value={data.sku}
                    onChange={handleChange}
                    placeholder="0058"
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        if (e.target.value) {
                          handleSearchProduct()
                        }
                      }
                    }}
                  />

                  <IconButton
                    isDisabled={!data.sku}
                    onClick={handleSearchProduct}
                    isLoading={isSearchProductLoading}
                    style={{
                      minWidth: 38,
                      height: 38,
                    }}
                  >
                    <Search />
                  </IconButton>
                </div>
              </Col>

              <Col>
                <Form.Label>Descrição</Form.Label>
                <Form.Control
                  name="descricao"
                  value={data.descricao}
                  onChange={handleChange}
                  placeholder="Produto..."
                  disabled
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 10,
                  }}
                >
                  <Form.Label
                    style={{
                      marginTop: 0,
                    }}
                  >
                    Fornecedor
                  </Form.Label>
                  {isSuppliersLoading && <CustomSpinner size={20} />}
                </div>

                <Form.Select
                  name="codfabricante"
                  value={data.codfabricante}
                  onChange={(e) => {
                    const supplier = suppliers.find(
                      (supplier) =>
                        String(supplier.cod_pessoa) === e.target.value,
                    )

                    setData((prevState) => ({
                      ...prevState,
                      codfabricante: supplier.cod_pessoa,
                      fabricante: supplier.pes_razao,
                    }))
                  }}
                  disabled={isSuppliersLoading}
                >
                  <option value="">
                    {isSuppliersLoading
                      ? 'Carregando...'
                      : 'Selecione o fornecedor'}
                  </option>

                  {suppliers.map((supplier) => (
                    <option
                      key={supplier.cod_pessoa}
                      value={supplier.cod_pessoa}
                    >
                      {supplier.pes_razao}
                    </option>
                  ))}
                </Form.Select>
              </Col>

              <Col>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 10,
                  }}
                >
                  <Form.Label
                    style={{
                      marginTop: 0,
                    }}
                  >
                    Categoria
                  </Form.Label>

                  {isCategoriesLoading && <CustomSpinner size={20} />}
                </div>

                <Form.Select
                  name="idcategoria"
                  value={data.idcategoria}
                  onChange={handleChange}
                  disabled={isCategoriesLoading}
                >
                  <option value="">
                    {isCategoriesLoading
                      ? 'Carregando...'
                      : 'Selecione a categoria'}
                  </option>

                  {categories.map((category) => (
                    <option
                      key={category.id_categoria}
                      value={category.id_categoria}
                    >
                      {category.categoria}
                    </option>
                  ))}
                </Form.Select>
              </Col>

              <Col>
                <Form.Label>SKU Principal</Form.Label>

                <Form.Control
                  name="skupai"
                  value={data.skupai}
                  onChange={handleChange}
                  placeholder="0035"
                />
              </Col>

              <Col>
                <Form.Label>Referência Produto</Form.Label>

                <Form.Control
                  name="refprodut"
                  value={data.refprodut}
                  onChange={handleChange}
                  placeholder="0000"
                />
              </Col>
            </Row>

            <hr />
            <h5 className="mb-3">Armazenamento</h5>

            <Row className="mb-3">
              <Col>
                <Form.Label>DUN</Form.Label>
                <Form.Control
                  name="dun"
                  value={data.dun}
                  onChange={handleChange}
                  placeholder="123456789"
                />
              </Col>

              <Col>
                <Form.Label>Embalagem</Form.Label>
                <Form.Control
                  name="embalagemarm"
                  value={data.embalagemarm}
                  onChange={handleChange}
                  placeholder="CX-50"
                />
              </Col>

              <Col>
                <Form.Label>Unidade</Form.Label>
                <Form.Select
                  name="unimasterarm"
                  value={data.unimasterarm}
                  onChange={handleChange}
                  disabled={isEmbalagensLoading}
                >
                  <option value="">
                    {isEmbalagensLoading
                      ? 'Carregando...'
                      : 'Selecione uma unidade'}
                  </option>

                  {embalagens.map((emb) => (
                    <option
                      key={emb.idembalagem}
                      value={emb.idembalagem}
                    >
                      {emb.embalagem}
                    </option>
                  ))}
                </Form.Select>
              </Col>

              <Col>
                <Form.Label>Quantidade</Form.Label>
                <CustomDecimalInput
                  name="qtunitmaster"
                  value={data.qtunitmaster}
                  onChange={handleChange}
                  placeholder="50"
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <Form.Label>Altura</Form.Label>
                <CustomDecimalInput
                  name="alturaarm"
                  value={data.alturaarm}
                  onChange={handleChange}
                  placeholder="1,00"
                />
              </Col>

              <Col>
                <Form.Label>Largura</Form.Label>
                <CustomDecimalInput
                  name="larguraarm"
                  value={data.larguraarm}
                  onChange={handleChange}
                  placeholder="1,00"
                />
              </Col>

              <Col>
                <Form.Label>Profundidade</Form.Label>
                <CustomDecimalInput
                  name="profundidadearm"
                  value={data.profundidadearm}
                  onChange={handleChange}
                  placeholder="1,00"
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <Form.Label>Peso Líquido</Form.Label>
                <CustomDecimalInput
                  name="pesoliqarm"
                  value={data.pesoliqarm}
                  onChange={handleChange}
                  placeholder="1,00"
                />
              </Col>

              <Col>
                <Form.Label>Peso Bruto</Form.Label>
                <CustomDecimalInput
                  name="pesobrutoarm"
                  value={data.pesobrutoarm}
                  onChange={handleChange}
                  placeholder="1,00"
                />
              </Col>

              <Col>
                <Form.Label>
                  Volume (cm<sup>3</sup>)
                </Form.Label>

                <CustomDecimalInput
                  name="volumearmcm"
                  value={data.volumearmcm}
                  onChange={handleChange}
                  placeholder="1,00"
                  disabled
                />
              </Col>

              <Col>
                <Form.Label>
                  Volume (m<sup>3</sup>)
                </Form.Label>

                <CustomDecimalInput
                  name="volumearmm"
                  value={data.volumearmm}
                  onChange={handleChange}
                  placeholder="1,00"
                  disabled
                />
              </Col>
            </Row>

            <hr />
            <h5 className="mb-3">Expedição</h5>

            <Row className="mb-3">
              <Col>
                <Form.Label>EAN</Form.Label>
                <Form.Control
                  name="ean"
                  value={data.ean}
                  onChange={handleChange}
                  placeholder="123456789"
                />
              </Col>

              <Col>
                <Form.Label>Embalagem</Form.Label>
                <Form.Control
                  name="embalagemexp"
                  value={data.embalagemexp}
                  onChange={handleChange}
                  placeholder="CX-50"
                />
              </Col>

              <Col>
                <Form.Label>Unidade</Form.Label>
                <Form.Select
                  name="unimasterexp"
                  value={data.unimasterexp}
                  onChange={handleChange}
                  disabled={isEmbalagensLoading}
                >
                  <option value="">
                    {isEmbalagensLoading
                      ? 'Carregando...'
                      : 'Selecione uma unidade'}
                  </option>

                  {embalagens.map((emb) => (
                    <option
                      key={emb.idembalagem}
                      value={emb.idembalagem}
                    >
                      {emb.embalagem}
                    </option>
                  ))}
                </Form.Select>
              </Col>

              <Col>
                <Form.Label>Quantidade</Form.Label>
                <CustomDecimalInput
                  name="qtunimasterexp"
                  value={data.qtunimasterexp}
                  onChange={handleChange}
                  placeholder="50"
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <Form.Label>Altura</Form.Label>
                <CustomDecimalInput
                  name="alturaexp"
                  value={data.alturaexp}
                  onChange={handleChange}
                  placeholder="1,00"
                />
              </Col>

              <Col>
                <Form.Label>Largura</Form.Label>
                <CustomDecimalInput
                  name="larguraexp"
                  value={data.larguraexp}
                  onChange={handleChange}
                  placeholder="1,00"
                />
              </Col>

              <Col>
                <Form.Label>Profundidade</Form.Label>
                <CustomDecimalInput
                  name="profundidadeexp"
                  value={data.profundidadeexp}
                  onChange={handleChange}
                  placeholder="1,00"
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <Form.Label>Peso Líquido</Form.Label>
                <CustomDecimalInput
                  name="pesoliqexp"
                  value={data.pesoliqexp}
                  onChange={handleChange}
                  placeholder="1,00"
                />
              </Col>

              <Col>
                <Form.Label>Peso Bruto</Form.Label>
                <CustomDecimalInput
                  name="pesobrutoexp"
                  value={data.pesobrutoexp}
                  onChange={handleChange}
                  placeholder="1,00"
                />
              </Col>

              <Col>
                <Form.Label>
                  Volume (cm<sup>3</sup>)
                </Form.Label>

                <CustomDecimalInput
                  name="volumeexpcm"
                  value={data.volumeexpcm}
                  onChange={handleChange}
                  placeholder="1,00"
                  disabled
                />
              </Col>

              <Col>
                <Form.Label>
                  Volume (m<sup>3</sup>)
                </Form.Label>

                <CustomDecimalInput
                  name="volumeexpm"
                  value={data.volumeexpm}
                  onChange={handleChange}
                  placeholder="1,00"
                  disabled
                />
              </Col>
            </Row>
          </>
        )}
      </Modal.Body>

      <Modal.Footer>
        <CustomButton
          title="Salvar"
          color="#229954"
          isLoadingText="Salvando..."
          isLoading={isRequestLoading}
          onClick={() => {
            onSubmit(data)
          }}
        >
          <CheckCircleFill />
        </CustomButton>

        <CustomButton
          title="Cancelar"
          color="#b03a2e"
          onClick={onClose}
        >
          <XCircleFill />
        </CustomButton>
      </Modal.Footer>
    </Modal>
  )
}
